// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import RightCircleFilledSvg from "@fishx/icons-svg/es/asn/RightCircleFilled";
import FishxIcon from '../components/FishxIcon';

var RightCircleFilled = function RightCircleFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: RightCircleFilledSvg
  }));
};

RightCircleFilled.displayName = 'RightCircleFilled';
export default React.forwardRef(RightCircleFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/RightCircleFilled.js
// module id = 4009
// module chunks = 0